import { FETCH_WAREHOUSE_SUCCESS, FETCH_WAREHOUSE_REQUEST, FETCH_WAREHOUSE_FAILURE } from "../../actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const warehouseReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_WAREHOUSE_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case FETCH_WAREHOUSE_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, data: null, error: null });
        case FETCH_WAREHOUSE_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload, data: null });
        default:
            return state;
    }
};
export default warehouseReducer;
